function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.00024C17.5225 2.00024 22 6.47736 22 12.0002C22 17.5225 17.5222 22.0002 12 22.0002C6.47779 22.0002 2 17.5225 2 12.0002C2 6.47736 6.47745 2.00024 12 2.00024ZM12 20.5002C16.6938 20.5002 20.5 16.694 20.5 12.0002C20.5 7.30582 16.6941 3.50024 12 3.50024C7.30586 3.50024 3.5 7.30582 3.5 12.0002C3.5 16.694 7.30621 20.5002 12 20.5002ZM13.8652 9.0647C14.1581 8.77181 14.633 8.77181 14.9258 9.0647C15.1921 9.33097 15.2163 9.74763 14.9985 10.0412L14.9258 10.1254L13.0597 11.9916L14.9274 13.8597C15.2203 14.1526 15.2202 14.6275 14.9273 14.9203C14.661 15.1866 14.2443 15.2107 13.9507 14.9929L13.8666 14.9202L11.999 13.0522L10.1338 14.9174C9.84095 15.2103 9.36608 15.2103 9.07319 14.9174C8.80692 14.6511 8.78271 14.2344 9.00057 13.9408L9.07319 13.8567L10.9384 11.9914L9.07063 10.1232C8.77777 9.83031 8.77781 9.35543 9.07074 9.06257C9.33703 8.79633 9.7537 8.77217 10.0473 8.99005L10.1314 9.06268L11.9991 10.9308L13.8652 9.0647Z",
  fill: "#BABAC8"
});

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.654e6938.svg";
export { ForwardRef as ReactComponent };